import { DefaultService } from '@/services/DefaultService';

export default class CockpitService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    get() {
        return this._http.get(`${this._env}/cockpit.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}